// @ts-nocheck
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { c2cApi } from "../../api/c2c-api";
import { currencyApi } from "../../api/currency-api";
import { financeApi } from "../../api/finance-api";
import { pledgeLng } from "../../api/pledge";
import PropertyCenter from "./components/propertyCenter";
import "./index.css";

export default function Property() {
  const uid = localStorage.getItem("uid");
  const navigate = useNavigate();
  const [userInfo, setuserInfo] = useState([] as any[]);
  const [arealist, setarealist] = useState([] as any[]);
  const [currencylist, setcurrencylist] = useState([] as any[]);
  const [cklist, setcklist] = useState([] as any[]);
  const { t: translate } = useTranslation();
  const [qbSum, setQbSum] = useState({} as any);
  const [visibleCK, setVisibleCK] = useState(false);
  const [visibleCKTS, setVisibleCKTS] = useState(false);
  const [visibleCKTS2, setVisibleCKTS2] = useState(false);
  const [visibleTK, setVisibleTK] = useState(false);
  const [isShowZF, setIsShowZF] = useState(false);
  const [loanAmount, setLoanAmount] = useState(0);
  // 是否借币
  const [pledgeStatus, setPledgeStatus] = useState(0);

  //c2c存款
  const [num, setNum] = useState("");
  const [currencyIdCK, setcurrencyIdCK] = useState(0);
  const [bankType, setbankType] = useState(0);
  //c2c 提款
  const [currencyIdTK, setcurrencyIdTK] = useState(0);

  //加载数 据
  const loadcklistData = async () => {
    const data = await c2cApi.czlist({ uid, type: 1 });
    if (data.ok) {
      setcklist(data.data);
      for (const item of data.data) {
        if (item.status == 1 || item.status == 4) {
          setIsShowZF(true);
          break;
        } else {
          setIsShowZF(false);
        }
      }
    }
  };

  const getpledgeLng = async () => {
    pledgeLng({ uid }).then((resp) => {
      if (resp.data) {
        setLoanAmount(resp.data.leftNum);
      }
    });
  };

  useEffect(() => {
    loadData();
    getpledgeLng();
    setPledgeStatus(Number(localStorage.getItem("pledgeStatus")));
  }, []);
  //加载数 据
  const loadData = async () => {
    const data = await financeApi.userCoin({ uid });
    if (data.ok) {
      setuserInfo(data.data);
    }
  };

  //加载数 据
  const loadCurrencyData = async () => {
    const data = await currencyApi.list({ pageNum: 1, pageSize: 100 });
    if (data.ok) {
      setcurrencylist(data.data?.records);
    }
  };

  //加载数 据
  const loadAreaData = async () => {
    const data = await c2cApi.arealist();
    if (data.ok) {
      setarealist(data.data);
    }
  };
  //加载数 据
  const loadQbSumData = async () => {
    const data = await financeApi.qbSum({ uid });
    if (data.ok) {
      setQbSum(data.data);
    }
  };

  //c2c存款
  const c2cCz = async () => {
    let dataInfo = {
      uid,
      num,
      bankType,
      currenyId: currencyIdCK,
    };
    const data = await c2cApi.cz(dataInfo);
    if (data.ok) {
      Toast.show({ content: data.data });
      setNum("");
      setbankType(0);
      setcurrencyIdCK(0);
      setVisibleCK(false);
      setVisibleCKTS(true);
    } else {
      Toast.show({ content: data.msg });
    }
    loadcklistData();
  };

  useEffect(() => {
    loadData();
    loadQbSumData();
    loadAreaData();
    loadcklistData();
    loadCurrencyData();
  }, []);
  return (
    <PropertyCenter
      userInfo={userInfo}
      qbSum={qbSum}
      setVisibleCK={setVisibleCK}
      setVisibleTK={setVisibleTK}
      setVisibleTK2={setVisibleCKTS2}
      isShowZF={isShowZF}
      loanAmount={loanAmount}
      pledgeStatus={pledgeStatus}
    />
  );
}
